module.exports = __webpack_public_path__ + "static/media/map_example.c57730ec.png";